import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Popconfirm, Table } from "antd";
import { EmptyState } from "@/shared/components/EmptyState";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { formatTableIndex } from "@/shared/utils/formatTableIndex";
import { tablePagination } from "@/shared/utils/tablePagination";
import { useDeleteOrganizationType, useOrganizationTypes } from "../hooks/useOrganizationTypes";
import { useOrgTypesStore } from "../store/org-types.store";
import type { OrganizationType } from "../types";

export function OrgTypeTable() {
	const { onOpen } = useOrgTypesStore();
	const { page: currentPage, limit: pageSize, setPage } = useUrlTableState();
	const { data, isLoading } = useOrganizationTypes({ page: currentPage, limit: pageSize });
	const { mutate: remove } = useDeleteOrganizationType();
	const items = data?.data?.items ?? [];
	const total = data?.data?.meta?.total ?? 0;

	return (
		<Table
			loading={isLoading}
			locale={{
				emptyText: <EmptyState description="Tashkilot turlari topilmadi" />,
			}}
			pagination={tablePagination({
				page: currentPage,
				limit: pageSize,
				total,
				onChange: (page, size) => setPage(page, size ?? pageSize),
			})}
			size="small"
			scroll={{ x: "max-content" }}
			dataSource={items}
			rowKey="id"
			columns={[
				{
					key: "#",
					title: "#",
					width: 60,
					align: "center",
					render: (_, __, index) => formatTableIndex(currentPage, pageSize, index),
				},
				{
					key: "name",
					title: "Nomi",
					dataIndex: "name",
				},
				{
					key: "actions",
					title: "Amallar",
					width: 80,
					align: "center",
					render: (_: unknown, record: OrganizationType) => (
						<Dropdown
							menu={{
								items: [
									{
										key: "edit",
										icon: <EditOutlined />,
										label: "Tahrirlash",
										onClick: () => onOpen(record),
									},
									{
										key: "delete",
										danger: true,
										label: (
											// biome-ignore lint/a11y/useKeyWithClickEvents: dropdown menu item
											// biome-ignore lint/a11y/noStaticElementInteractions: dropdown menu item
											<div onClick={(e) => e.stopPropagation()}>
												<Popconfirm
													title="O'chirish"
													description="Rostdan ham o'chirmoqchimisiz?"
													onConfirm={() => remove(record.id)}
													okText="Ha"
													cancelText="Yo'q"
													okButtonProps={{ danger: true }}
												>
													<div
														style={{
															width: "100%",
															display: "flex",
															alignItems: "center",
															gap: "8px",
														}}
													>
														<DeleteOutlined />
														<span>O&apos;chirish</span>
													</div>
												</Popconfirm>
											</div>
										),
									},
								],
							}}
							trigger={["click"]}
							placement="bottomRight"
						>
							<Button type="text" icon={<MoreOutlined />} size="small" />
						</Dropdown>
					),
				},
			]}
		/>
	);
}
